const iconsArticles = [
					{
						label: "",
						value: "fas fa-caravan",
						icon: "fas fa-caravan"
					},
					{	
						label: "",
						value: "fas fa-shuttle-van",
						icon: "fas fa-shuttle-van",
					},
					{	
						label: "",						
						value: "fas fa-truck-loading",
						icon: "fas fa-truck-loading"
					},
					{	
						label: "",
						value: "fas fa-car-side",
						icon: "fas fa-car-side"
					}, 					
					{	
						label: "",
						value: "fas fa-truck-monster",
						icon: "fas fa-truck-monster"
					},
					{	
						label: "",
						value: "fas fa-truck",
						icon: "fas fa-truck"
					},
					{	
						label: "",
						value: "fas fa-truck-moving",
						icon: "fas fa-truck-moving"
					},
					
					{	
						label: "",
						value: "fas fa-motorcycle",
						icon: "fas fa-motorcycle"
					},					
					{
						label: "",
						value : "fas fa-ship",
						icon : "fas fa-ship",
					},
					{
						label: "",
						value: "fas fa-box-open"	,
						icon: "fas fa-box-open"	
					},
					{
						label: "",
						value: "fas fa-couch",
						icon: "fas fa-couch"
					},
					{
						label: "",
						value: "fas fa-dolly-flatbed",
						icon: "fas fa-dolly-flatbed"
					}
				];

const 	iconsEtats = [
					{
						label: "",
						value: "fas fa-dolly-flatbed",
						icon: "fas fa-dolly-flatbed"
					},
					{
						label: "",
						value: "fas fa-boxes",
						icon: "fas fa-boxes"
					},
					{
						label: "",
						value: "fas fa-pallet",
						icon: "fas fa-pallet"
					},
					{
						label: "",
						value: "fas fa-window-restore",
						icon: "fas fa-window-restore"
					},
						{
						label: "",
						value: "fas fa-thumbs-up",
						icon: "fas fa-thumbs-up"
					},
					{
						label: "",
						value: "fas fa-play",
						icon: "fas fa-play"
					},
					{
						label: "",
						value: "fas fa-door-open",
						icon: "fas fa-door-open"
					},
					{
						label: "",
						value: "fas fa-door-closed",
						icon: "fas fa-door-closed"
					},
						{
						label: "",
						value: "fas fa-sign-out-alt",
						icon: "fas fa-sign-out-alt"
					},
					{
						label: "",
						value: "fas fa-check",
						icon: "fas fa-check"
					},
					{
						label: "",
						value: "fas fa-plus",
						icon: "fas fa-plus"
					},
					{
						label: "",
						value: "fas fa-cart-plus",
						icon: "fas fa-cart-plus"
					},
					
]


export default {
	iconsArticles: iconsArticles,
	iconsEtats: iconsEtats
}
